import { get, patch, post } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';
import { WarehouseDevicesService } from '@/services/warehouse-devices.service';

export default {
  getItemsList({ commit }, { params } = {}) {
    return WarehouseDevicesService.getList({
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      return response;
    });
  }
};
